export default __webpack_public_path__ + "static/media/you-can-do-it-2048w.72dd5ed9.png";